export default __webpack_public_path__ + "static/media/take-assessment.c6ce935e.svg";